var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-unavailable.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/urls.j2", false, "product/templates/product-unavailable.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("brandsUrl")) {
var t_4 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_4);
output += "\n\n\n<div class=\"o-row c-product-container c-product-message__unavailable--outer dom-main-product\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8 o-large--centered o-extra-large--6 c-product-message__unavailable--inner\">\n\n        <p class=\"c-product-message__unavailable\">\n            ";
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_unavailable-message"])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-unavailable.j2"] , dependencies)